import { Avatar } from '@snack-uikit/avatar';
import { Typography } from '@snack-uikit/typography';
import { useAuth } from 'react-oidc-context';

import { getShortUserInitials } from '@/utils/oidc';

export function ProfileBadge() {
  const { user } = useAuth();

  return <Avatar appearance='green' showTwoSymbols name={getShortUserInitials(user)} />;
}

export function FullUserInitials() {
  const { user } = useAuth();

  return (
    <Typography.SansBodyS>
      {user?.profile.given_name} {user?.profile.family_name}
    </Typography.SansBodyS>
  );
}
